module.exports = __webpack_public_path__ + "img/FinancialDocumentChecklist.74f621a5.svg";